export default __webpack_public_path__ + "static/media/image2-6.b4640776.png";